import { TableStateMessage, TableStateSpinner } from "./AdminPage.styles";

interface ITableLoadingStateProps {
  /** Overrides the default wording, e.g. "Loading this ward's types…". */
  label?: string;
}

/**
 * A table's loading state (EN-5146 UI feedback).
 *
 * Every admin table used to pass the bare string "Loading..." as its
 * `emptyStateText`, which `TableSorted` renders in the same grey paragraph it
 * uses for "No rows found" — so a slow request and an empty result looked
 * identical, and both read as a sentence dropped under the header. A spinner
 * beside the word is the whole difference: it says the table is still coming.
 */
export function TableLoadingState({
  label = "Loading…",
}: ITableLoadingStateProps) {
  return (
    <TableStateMessage>
      <TableStateSpinner aria-hidden="true" />
      {label}
    </TableStateMessage>
  );
}
